// source: type/order_bundle.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var type_bundled_item_pb = require('../type/bundled_item_pb.js');
goog.object.extend(proto, type_bundled_item_pb);
goog.exportSymbol('proto.type.OrderBundle', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderBundle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.type.OrderBundle.repeatedFields_, null);
};
goog.inherits(proto.type.OrderBundle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderBundle.displayName = 'proto.type.OrderBundle';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.type.OrderBundle.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderBundle.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderBundle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderBundle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderBundle.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundledItemsList: jspb.Message.toObjectList(msg.getBundledItemsList(),
    type_bundled_item_pb.BundledItem.toObject, includeInstance),
    customerIntendedBundledItemsList: jspb.Message.toObjectList(msg.getCustomerIntendedBundledItemsList(),
    type_bundled_item_pb.BundledItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of OrderBundle as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderBundle.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.bundledItemsList;

  /** @type {?|undefined} */
  this.customerIntendedBundledItemsList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderBundle.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderBundle}
 */
proto.type.OrderBundle.fromObject = function(obj) {
  var msg = new proto.type.OrderBundle();
  obj.bundledItemsList && jspb.Message.setRepeatedWrapperField(
      msg, 1, obj.bundledItemsList.map(
          type_bundled_item_pb.BundledItem.fromObject));
  obj.customerIntendedBundledItemsList && jspb.Message.setRepeatedWrapperField(
      msg, 2, obj.customerIntendedBundledItemsList.map(
          type_bundled_item_pb.BundledItem.fromObject));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderBundle}
 */
proto.type.OrderBundle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderBundle;
  return proto.type.OrderBundle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderBundle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderBundle}
 */
proto.type.OrderBundle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new type_bundled_item_pb.BundledItem;
      reader.readMessage(value,type_bundled_item_pb.BundledItem.deserializeBinaryFromReader);
      msg.addBundledItems(value);
      break;
    case 2:
      var value = new type_bundled_item_pb.BundledItem;
      reader.readMessage(value,type_bundled_item_pb.BundledItem.deserializeBinaryFromReader);
      msg.addCustomerIntendedBundledItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderBundle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderBundle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderBundle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderBundle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundledItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      type_bundled_item_pb.BundledItem.serializeBinaryToWriter
    );
  }
  f = message.getCustomerIntendedBundledItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      type_bundled_item_pb.BundledItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BundledItem bundled_items = 1;
 * @return {!Array<!proto.type.BundledItem>}
 */
proto.type.OrderBundle.prototype.getBundledItemsList = function() {
  return /** @type{!Array<!proto.type.BundledItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, type_bundled_item_pb.BundledItem, 1));
};


/**
 * @param {!Array<!proto.type.BundledItem>} value
 * @return {!proto.type.OrderBundle} returns this
*/
proto.type.OrderBundle.prototype.setBundledItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.type.BundledItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.type.BundledItem}
 */
proto.type.OrderBundle.prototype.addBundledItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.type.BundledItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.type.OrderBundle} returns this
 */
proto.type.OrderBundle.prototype.clearBundledItemsList = function() {
  return this.setBundledItemsList([]);
};


/**
 * repeated BundledItem customer_intended_bundled_items = 2;
 * @return {!Array<!proto.type.BundledItem>}
 */
proto.type.OrderBundle.prototype.getCustomerIntendedBundledItemsList = function() {
  return /** @type{!Array<!proto.type.BundledItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, type_bundled_item_pb.BundledItem, 2));
};


/**
 * @param {!Array<!proto.type.BundledItem>} value
 * @return {!proto.type.OrderBundle} returns this
*/
proto.type.OrderBundle.prototype.setCustomerIntendedBundledItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.type.BundledItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.type.BundledItem}
 */
proto.type.OrderBundle.prototype.addCustomerIntendedBundledItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.type.BundledItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.type.OrderBundle} returns this
 */
proto.type.OrderBundle.prototype.clearCustomerIntendedBundledItemsList = function() {
  return this.setCustomerIntendedBundledItemsList([]);
};


goog.object.extend(exports, proto.type);
